import { Figure } from "components/Figure"
import { Comments } from "components/Icon"
import { useTranslator } from "components/Translator"

export const CommentsCounter = ({ nbComments }) => {
  const translator = useTranslator()

  return (
    <Figure
      icon={<Comments className="w-4" />}
      label={translator.trans("CommentsCounter.label", {
        nbComments,
      })}
    />
  )
}
